import config from "../conf/config.js";
import store from "../../../store/index";
import IsPc from "./IsPc";
import axios from 'axios';
import router from '../../../router';

let refreshToken = function(){
    let sessionid = window.localStorage.getItem("sessionid")
    let type = ""
    if(IsPc()){
        type = "wx"
    }else{
        type = "pc"
    };
    axios({
        method:'post',
        url:config.baseApi + "/refresh_token",
        changeOrigin: true,
        headers: {
              'Content-Type': 'application/json',
              'token':sessionid
          },
        data:JSON.stringify({
            refresh_token:store.state.user.refresh_token,
            openid:store.state.user.openid,
            type:type
        })
    }).then(function (res) {
        if(res.data.code == 1){
            // console.log("微信token刷新成功")
        }
    });
    axios({
        method:'post',
        url:config.baseApi + "/refresh_session",
        changeOrigin: true,
        headers: {
            'Content-Type': 'application/json',
            'token':sessionid
        },
    }).then(function (res) {
        if(res.data.code == 1){
            // console.log("本地token刷新成功")
        } else {
            // console.log("本地token刷新Fail")
        }
    });
}
export default refreshToken;